<!--
    校区管理-学生管理-班级
    功能：展示学生所在班级的记录数据
    组件:AppList、AppSearch
-->
<template>
  <div class="student_class">
    <div class="total clearfix" v-if="list.items && list.items.length > 0">
      <span>{{ name }}学生</span>
      <span>手机号：{{ mobile }}</span>
<!--      <span>总上课次数：<b>0</b></span>-->
    </div>
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      :api="`/api/my-classes/${id}`">
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="80px"
            class="orgin-btn">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="ClassDetail(scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  export default {
    name: "StudentClass",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id,
        mobile: this.$route.params.mobile,
        name: this.$route.params.name,
        list: {},
        columns: [],
      }
    },
    computed: {
      role() {
        return this.$store.state.user;
      },
    },
    created() {
      this.columns = [
        { prop: 'classes.name', label: '班级名称' },
        { prop: 'classes.teacher.name', label: '负责老师' },
        { prop: 'created_at', label: '创建时间' },
        { prop: 'classes.teaching_status_text', label: '班级状态' },
        { prop: 'classes.student_count', label: '学生数' },
        { prop: 'classes.teaching_count', label: '累计上课次数' }
      ];
    },
    methods: {
      ClassDetail(row) {
        this.$router.push(`/student/detail/${row.classes.id}`)
      },
    }
  }
</script>

<style scoped lang="scss">
  .student_class {
    .total {
      text-align: left;
      font-size: 16px;
      color: var(--color-primary);
      margin-bottom: 10px;
      span {
        margin: 0 10px;
        b {
          margin: 0 5px;
        }
      }
      .class_btn {
        float: right;
      }
    }
  }
</style>

<style lang="scss">
  .student_class {
    .app-list {
      .list-header {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Student/Class.vue